import {Box, HStack, Icon} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

interface ImagePreviewZoomActionsProps {
  onZoomOut: VoidFunction;
  onZoomIn: VoidFunction;
}

const zoomActionsPositionVariants = cva(
  'absolute right-0 bottom-0 z-[var(--z-lightbox-detail-actions)]'
);
const zoomActionsVariants = cva(
  'rounded-[var(--radius-small)] bg-[var(--color-palettes-black-900-70)] text-[var(--color-general-white)]'
);

export function ImagePreviewZoomActions(props: ImagePreviewZoomActionsProps) {
  return (
    <div className={cn(zoomActionsPositionVariants())}>
      <div className={cn(zoomActionsVariants())}>
        <HStack>
          <Box padding={2} opacity={ACTIONS_OPACITY}>
            <Icon value="content/remove" onClick={props.onZoomOut} />
          </Box>
          <Box padding={2} opacity={ACTIONS_OPACITY}>
            <Icon value="content/add" onClick={props.onZoomIn} />
          </Box>
        </HStack>
      </div>
    </div>
  );
}

const ACTIONS_OPACITY = 0.6;
